import { FC } from 'react';
import { styled, Typography } from '@mui/material';

import { TRouteInputValue } from '../types';

import { WithAddressLines } from './WithAddressLines';

interface IAddressLineViewProps {
	value?: TRouteInputValue;
	placeholder?: string;
}

const EllipsisWrapper = styled('div')({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	flex: 1,
	minWidth: 0,
});

const AddressFormatted: FC<IAddressLineViewProps> = ({
	value,
	placeholder,
}) => {
	if (!value) {
		return (
			<Typography variant="b2" color="solutions.600" noWrap>
				{placeholder}
			</Typography>
		);
	}

	const { address } = value;

	if (!address) {
		return (
			<Typography variant="b2" color="primary.main" noWrap>
				{value.title}
			</Typography>
		);
	}

	return (
		<WithAddressLines value={value}>
			{({ primary, secondary }) => (
				<>
					<Typography variant="b2" color="primary.main" component="span" noWrap>
						{primary}
					</Typography>
					{secondary && (
						<Typography
							variant="b2"
							color="solutions.600"
							component="span"
							noWrap
						>
							{' '}
							{secondary}
						</Typography>
					)}
				</>
			)}
		</WithAddressLines>
	);
};

export const AddressLineView: FC<IAddressLineViewProps> = (props) => {
	return (
		<EllipsisWrapper>
			<AddressFormatted {...props} />
		</EllipsisWrapper>
	);
};
